export const CART = 'CART';
export const CART_ALL_ACTION = `${CART}/ALL`;
export const CART_UPDATE_ACTION = `${CART}/UPDATE`;
export const CART_DELETE_ACTION = `${CART}/DELETE`;
export const CART_ADD_ACTION = `${CART}/ADD`;
export const CART_CLEAN_ACTION = `${CART}/CLEAN`;
export const CART_CALCULATE_FEES_ACTION = `${CART}/CALCULATE_FEES`;

export const INCREASE_QUANTITY = 'INCREASE_QUANTITY';
export const DECREASE_QUANTITY = 'DECREASE_QUANTITY';
export const SET_TOTAL_CHARGE = 'SET_TOTAL_CHARGE';
